export function OutlinedElearningSettingsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/outlined-elearning-settings.svg'"></ng-include>`
    }
}